import { useSmallScreen } from '@/hooks/useWindowDimension';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';
import classes from './EncroachmentLegend.module.css';

export const EncroachmentLegend = ({
  showOverhang = false,
}: {
  showOverhang?: boolean;
}) => {
  const isSmallScreen = useSmallScreen();
  const riskType = showOverhang ? 'overhang' : 'encroachment';
  return (
    <div data-testid="encroachment-legend">
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle}>
          {`Tree cover by ${riskType} risk`}
        </div>
      )}
      <div className={`${legendClasses.legend} ${classes.layout}`}>
        <span className={classes.gradient} />
        <span style={{ textAlign: 'left' }}>
          Far
          <br />
          from the line
        </span>
        <span style={{ textAlign: 'right' }}>
          Close
          <br />
          to the line
        </span>
      </div>
    </div>
  );
};
